import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { AppProviders } from "./app/app-providers";
import { router } from "./app/router";
import { registerServiceWorker } from "./platform/register-service-worker";
import { GlobalSelectSearch } from "./ui/global-select-search";
import "./app/styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Application root element is missing.");
}

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <GlobalSelectSearch />
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);

void registerServiceWorker();
